export const aspectRatioAsNumber = (aspectRatioString: string) => {
	if (aspectRatioString === null || aspectRatioString === undefined) return 0;
	const [width, height] = aspectRatioString.split(':');
	const aspectRatio = Number(height) / Number(width);
	return aspectRatio;
};
